export interface IKeyboardEventHandleable {
  handleKeyboardEvent(event: KeyboardEvent): boolean;
}

export function instanceOfIKeyboardEventHandleable(instance: any): instance is IKeyboardEventHandleable {
  return instance
    && (instance.handleKeyboardEvent !== undefined);
}
